import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizedDate',
  standalone: true,
})
export class LocalizedDatePipe implements PipeTransform {

  constructor(private translateService: TranslateService, private datePipe: DatePipe) { }

  transform(value: number | Date | string, pattern: string = 'mediumDate'): string | null {
    return this.datePipe.transform(value, pattern, undefined, this.translateService.currentLang);
  }
}
